import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import DoctorDetails from "../components/DoctorDetails";
import CustomToolbar from "../components/CustomToolbar";
import AppointmentForm from "../components/AppointmentForm";
import DashboardTabs from "../components/DashboardTabs";

const localizer = momentLocalizer(moment);

const appointmentTypes = [
  "New Patient",
  "Follow-Up",
  "Annual Physical",
  "Sick Visit",
  "Urgent Visit",
  "Chronic Care Management",
  "Medication Refill",
  "Lab Test",
  "Diagnostic Imaging",
  "Vaccination",
  "Preventive Screening",
  "Specialist Consultation",
  "Telehealth",
  "Procedure",
  "Post-Operative Follow-Up",
  "Prenatal Visit",
  "Pediatric Visit",
  "Mental Health Consultation",
  "Physical Therapy",
  "Other",
];

const doctorName = "Dr. Strange";

function RequestAppointment() {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [appointmentType, setAppointmentType] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedStartTime, setSelectedStartTime] = useState("");
  const [selectedEndTime, setSelectedEndTime] = useState("");

  const events = [
    {
      title: "Consultation - Dr. Smith",
      start: new Date(2026, 6, 29, 10, 0),
      end: new Date(2026, 6, 29, 11, 0),
    },
    {
      title: "Follow-up - Patient A",
      start: new Date(2026, 6, 30, 14, 0),
      end: new Date(2026, 6, 30, 15, 0),
    },
    {
      title: " Prenatal Visit- Dr. Smith",
      start: new Date(2026, 6, 31, 10, 0),
      end: new Date(2026, 6, 31, 11, 0),
    },
    {
      title: "Follow-up - Patient A",
      start: new Date(2026, 7, 1, 14, 0),
      end: new Date(2026, 7, 1, 15, 0),
    },
  ];

  const buildSlotFromInputs = (dateValue, startTimeValue, endTimeValue) => {
    if (!dateValue || !startTimeValue || !endTimeValue) {
      return null;
    }

    const start = new Date(`${dateValue}T${startTimeValue}:00`);
    const end = new Date(`${dateValue}T${endTimeValue}:00`);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return null;
    }

    return {
      start,
      end,
    };
  };

  const handleCalendarSelect = (slotInfo) => {
    setSelectedSlot(slotInfo);
    setSelectedDate(moment(slotInfo.start).format("YYYY-MM-DD"));
    setSelectedStartTime(moment(slotInfo.start).format("HH:mm"));
    setSelectedEndTime(moment(slotInfo.end).format("HH:mm"));
  };

  const handleManualSlotChange = (dateValue, startTimeValue, endTimeValue) => {
    setSelectedDate(dateValue);
    setSelectedStartTime(startTimeValue);
    setSelectedEndTime(endTimeValue);
    setSelectedSlot(
      buildSlotFromInputs(dateValue, startTimeValue, endTimeValue),
    );
  };

  // Merge selected slot into events with chosen appointment type
  const allEvents = selectedSlot
    ? [
        ...events,
        {
          ...selectedSlot,
          title: appointmentType
            ? `${appointmentType} - ${doctorName}`
            : `Selected Slot - ${doctorName}`,
          isSelected: true,
        },
      ]
    : events;

  // Find earliest event start
  const earliestEvent =
    events.length > 0
      ? events.reduce((min, e) => (e.start < min.start ? e : min), events[0])
      : null;

  return (
     <div className='container' >
      {/* Doctor Details Section */}
      {/* <DoctorDetails /> */}
 {/* <DashboardTabs  name={'bookapt'} /> */}
      <div className="review-grid">
        {/* Left side: Appointment Form */}
        <div className="panel-card">
          <AppointmentForm
            appointmentTypes={appointmentTypes}
            appointmentType={appointmentType}
            setAppointmentType={setAppointmentType}
            selectedSlot={selectedSlot}
            selectedDate={selectedDate}
            selectedStartTime={selectedStartTime}
            selectedEndTime={selectedEndTime}
            handleManualSlotChange={handleManualSlotChange}
          />
        </div>

        {/* Right side: Calendar */}
        <div className="panel-card">
          <h2 className="page-heading">Available Slots</h2>
          <Calendar
            localizer={localizer}
            events={allEvents}
            startAccessor="start"
            endAccessor="end"
            selectable
            onSelectSlot={(slotInfo) => handleCalendarSelect(slotInfo)}
            onSelectEvent={(event) => handleCalendarSelect(event)}
            defaultView="week"
            components={{
              toolbar: CustomToolbar, // override default toolbar
            }}
            eventPropGetter={(event) => {
              if (event.isSelected) {
                return {
                  style: {
                    backgroundColor: "#22c55e", // green highlight for selected slot
                    color: "#fff",
                    borderRadius: "6px",
                  },
                };
              }
              return {
                style: {
                  backgroundColor: "#0f4c81", // default booked slot color
                  color: "#fff",
                },
              };
            }}
            style={{ height: 600 }}
            scrollToTime={
              earliestEvent
                ? earliestEvent.start
                : new Date(new Date().setHours(9, 0, 0, 0))
            }
          />
        </div>
      </div>
    </div>
  );
}

export default RequestAppointment;
